// @ngInject
function stateConfig($stateProvider){

    $stateProvider.state('base.deliveryplanningtemplates.new', {
        url:'/new',
        views: {
            'baseView@base':{
                remplateUrl: 'main/base/deliveryplanningtemplates/deliveryplanningtemplate/deliveryplanningtemplate.tpl.html',
                controller: 'DeliveryPlanningTemplateController as vm'
        }},
        resolve: {
                deliveryplanningtemplate: function() {return {}; },
                isNewDeliveryPlanningTemplate: function() {return true;}
        }
    });

    $stateProvider.state('base.deliveryplanningtemplates.deliveryplanningtemplate', {
        url:'/{deliveryplanningtemplateId}',
        views: {
            'baseView@base':{
                templateUrl: 'main/base/deliveryplanningtemplates/deliveryplanningtemplate/deliveryplanningtemplate.tpl.html',
                controller: 'DeliveryPlanningTemplateController as vm'
        }},
        resolve: {
            deliveryplanningtemplate: deliveryplanningtemplateResolver,
            isNewDeliveryPlanningTemplate: function() {return false;}
        }
    });
}

// @ngInject
function deliveryplanningtemplateResolver($stateParams, DeliveryPlanningTemplatesApiService) {
    return DeliveryPlanningTemplatesApiService.getDeliveryPlanningTemplate($stateParams.deliveryplanningtemplateId);
}

// @ngInject
function DeliveryPlanningTemplateController($state, deliveryplanningtemplate, DeliveryPlanningTemplatesApiService, ToasterService, confirmationDialogService, $translate, isNewDeliveryPlanningTemplate) {
    var vm = this;

    var deliveryplanningtemplateCopy = {};

    vm.deliveryplanningtemplate = deliveryplanningtemplate;

    console.log(vm.deliveryplanningtemplate);

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveDeliveryPlanningTemplate = saveDeliveryPlanningTemplate;
    vm.deleteDeliveryPlanningTemplate = deleteDeliveryPlanningTemplate;
    vm.isNewDeliveryPlanningTemplate = isNewDeliveryPlanningTemplate;
    vm.isEditing = vm.isNewDeliveryPlanningTemplate;

    vm.isAllInformationValid = isAllInformationValid;
    //vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if(vm.isNewDeliveryPlanningTemplate){
            vm.deliveryplanningtemplate = {};
        }
    }

    function enableEditing(){
        deliveryplanningtemplateCopy = angular.copy(vm.deliveryplanningtemplate);
        vm.isEditing = true;
    }

    function cancelEditing(){
        vm.deliveryplanningtemplate = deliveryplanningtemplateCopy;
        vm.isEditing = false;
    }

    function saveDeliveryPlanningTemplate() {
        if(vm.isNewDeliveryPlanningTemplate) {
            saveNewDeliveryPlanningTemplate();
        } else {
            updateDeliveryPlanningTemplate();
        }
    }

    function saveNewDeliveryPlanningTemplate() {
        loadSpinnerService.start('mainSpinner');
        DeliveryPlanningTemplatesApiService.createDeliveryPlanningTemplate(vm.deliveryplanningtemplate).then(function(response){
            vm.deliveryplanningtemplate = response;
            prepareData();
            vm.isNewDeliveryPlanningTemplate = false;
            vm.isEditing = false;
            $state.go('base.deliveryplanningtemplates.deliveryplanningtemplate', {deliveryplanningtemplateId: vm.deliveryplanningtemplate.id});
        }, function(error){
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateDeliveryPlanningTemplate() {
        loadSpinnerService.start('mainSpinner');
        DeliveryPlanningTemplatesApiService.updateDeliveryPlanningTemplate(vm.deliveryplanningtemplate).then(function(response){
            vm.deliveryplanningtemplate = response;
            prepareData();
            vm.isNewDeliveryPlanningTemplate = false;
            vm.isEditing = false;
            $state.go('base.deliveryplanningtemplates.deliveryplanningtemplate', {deliveryplanningtemplateId: vm.deliveryplanningtemplate.id});
        }, function(error){
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteDeliveryPlanningTemplate() {
        confirmationDialogService.showDialog($translate.instant('deliveryplanningtemplates.confirmDelete'))
            .then(function(confirmation) {
                if(confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    DeliveryPlanningTemplatesApiService.updateDeliveryPlanningTemplate(vm.deliveryplanningtemplate).then(function(response){
                        vm.deliveryplanningtemplate = response;
                        prepareData();
                        vm.isNewDeliveryPlanningTemplate = false;
                        vm.isEditing = false;
                        $state.go('base.deliveryplanningtemplates');
                    }, function(error){
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function prepareData() {
        if (vm.deliveryplanningtemplate === undefined) {
            return;
        }

        vm.deliveryplanningtemplateCopy = angular.copy(vm.deliveryplanningtemplate);
    }

    function isAllInformationValid() {
        return true;
    }
}

angular
    .module('deliveryplanningtemplates.deliveryplanningtemplate', [])
    .config(stateConfig)
    .controller('DeliveryPlanningTemplateController', DeliveryPlanningTemplateController);